export default __webpack_public_path__ + "static/media/email.99ae3e56.svg";